// extracted by mini-css-extract-plugin
export default {"footer":"AppFooter_footer__XogjZ","footer__block":"AppFooter_footer__block__55EgO","footer__block--sparse":"AppFooter_footer__block--sparse__KVgfP"};